import React, { useEffect, useState } from 'react'
import { faFileUpload, faSquareCheck } from '@fortawesome/free-solid-svg-icons'

import StepBar from 'app/common/StepBar'
import {
  DcButton,
  DcInput,
  Link,
  PixelFactoryContext,
  DcDropDown,
  SectionContent,
  DcOverlaySlider,
} from 'pixel-base'
import styled from 'styled-components'
import { getOrderMeta, uploadExcelSheet } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../decl.d'

interface IProps {
  show: boolean
  handleClose: (success: boolean) => void
}

const UploadExcelOrder = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [show, setShow] = useState(false)
  const [error, setError] = useState({ error: '', field: '' })
  const [vendors, setVendors] = useState([])
  const [activeStep] = React.useState('upload')
  const [data, setData] = React.useState({
    name: '',
    id: '',
    current_file: null,
  })

  useEffect(() => {
    setShow(props.show)
  }, [props.show])

  const Steps = [
    {
      icon: faFileUpload,
      active: false,
      title: 'upload',
    },
    {
      icon: faSquareCheck,
      active: false,
      title: 'product',
    },
  ]
  const handleDownloadCsvFile = () => {
    const csvData = [
      [
        'Order_No',
        'Customer_Name',
        'Phone',
        'City',
        'Address',
        'Product_Name',
        'Product_Unit_Price',
        'Product_Quantity',
      ],
    ]
    const csvContent =
      'data:text/csv;charset=utf-8,' + csvData.map((e) => e.join(',')).join('')
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'orders.csv')
    document.body.appendChild(link)
    link.click()
  }

  const uploadExecFile = () => {
    getOrderMeta().subscribe((res) => {
      if (res.response.data) {
        const meta = res.response.data
        if (meta && meta.allowed_businesses) {
          const extractedData = meta.allowed_businesses.map((item) => ({
            name: item.name,
            id: item.id,
          }))
          setVendors(extractedData)
        }
      }
    })
  }

  React.useEffect(() => {
    uploadExecFile()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    uploadExcelSheet(data?.current_file, data).subscribe((res: any) => {
      if (res && res.response?.data) {
        hidePageLoader()
        showSuccess('Sheet Record uploaded successfully')
        props.handleClose(true)
      } else if (res.response?.error) {
        hidePageLoader()
        setError({ error: res.response.error, field: '' })
        showFailure(res.response?.error ?? 'something went wrong')
      }
    })
  }

  return (
    <DcOverlaySlider
      title={'Upload File'}
      isOpen={show}
      width="40vw"
      onClose={() => {
        setShow(false)
        props.handleClose(true)
      }}
    >
      <SectionContent>
        <Form onSubmit={handleSubmit}>
          <StepBar size="sm" Steps={Steps} activeStep={activeStep} />

          <FormGroup>
            <>
              <strong></strong> Easily upload your orders with our{' '}
              <Link
                onClick={() => handleDownloadCsvFile()}
                style={{ fontSize: '14px' }}
              >
                template
              </Link>{' '}
              and pick the vendor to showcase your orders.
            </>
          </FormGroup>
          <FormGroup>
            <DcInput
              error={
                error.field === 'current_file' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'file'}
              name={'Select  File'}
              placeholder={'Select File'}
              onChange={(e) =>
                setData({
                  ...data,
                  current_file: e.target.files[0],
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <DcDropDown
              required
              error={
                error.field === 'id' && error.error !== '' ? error.error : null
              }
              placeholder="Showing Order In Vendor"
              options={[...vendors].map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                }
              })}
              value={data.id}
              onChange={(e) => {
                setData({
                  ...data,
                  id: e.target.value,
                })
              }}
            />
          </FormGroup>
          <FormGroup flexEnd>
            <DcButton size="sm" variant="primary" type="submit">
              Upload
            </DcButton>
          </FormGroup>
        </Form>
      </SectionContent>
    </DcOverlaySlider>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default UploadExcelOrder
